import ChatContentLifeSciences from '../../../components/modules/chat/chat-content/ChatLifeSciences';

const ChatConversationLifeSciences = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%',
        padding: '16px 28px 28px 16px'
      }}
    >
      <div style={{ width: '100%', maxWidth: '1100px' }}>
        <h1
          className="fw-bold text-body-emphasis mb-3"
          style={{ fontSize: '1.6rem', lineHeight: 1.2, letterSpacing: '-0.01em' }}
        >
          AI Compliance and Regulatory Conversational Agent
        </h1>
        <ChatContentLifeSciences />
      </div>
    </div>
  );
};

export default ChatConversationLifeSciences;
